




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { GetLogsDetail } from '@/@types/theoryGit/logs';
import { GitRepositoryDetailHeaderTitle } from '@/@types/LibraryComponent';

interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}

@Component({
  components: {
    AccountIcon,
  },
})
export default class Commits extends Vue {
  @Prop({ required: true, default: () => [] })
  private commitLogs!: GetLogsDetail[];
  private headers = GitRepositoryDetailHeaderTitle.commitHeader;
  private pageOption: PageOption = {
    count: 20,
    max: 5,
    min: 1,
    current: 1,
  };

  private sliceOid(oid: string) {
    return oid.slice(0, 10);
  }
}
